import { render, staticRenderFns } from "./OsPreditivaArmazem.vue?vue&type=template&id=0f045a01&"
import script from "./OsPreditivaArmazem.vue?vue&type=script&lang=js&"
export * from "./OsPreditivaArmazem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports